import React, { Component } from "react";

interface IGameGuideComponent {
    data: {}
}
export const gameGuideComponent: IGameGuideComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    {
                        "id": "gameScrollComponent",
                        "name": "gameScrollComponent",
                        "type": "Container",
                        "x": 0,
                        "y": 0,
                        "visible": true,
                        "filterTypes": [],
                        child: [

                        ]
                    },
                    {
                        "id": "gameGuideContent",
                        "name": "gameGuideContent",
                        "type": "Container",
                        "x": -100,
                        "y": -200,
                        "visible": true,
                        "filterTypes": [],
                        child: [

                            {
                                "id": "rulesContainer",
                                "name": "rulesContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Rules_Heading",
                                        "name": "Rules_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Rules_Description1",
                                        "name": "Rules_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_0_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "Rules_Description2",
                                        "name": "Rules_Description2",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 340,
                                        "width": 600,
                                        "visible": false,
                                        "text": "tag-help-rules_0_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "Rules_Description2_zx",
                                        "name": "Rules_Description2_zx",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 340,
                                        "width": 600,
                                        "visible": false,
                                        "text": "tag-help-rules_0_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "Rules_Description3",
                                        "name": "Rules_Description3",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 444,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_0_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "Rules_Description3_zs",
                                        "name": "Rules_Description3_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 444,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_0_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "Rules_Description4",
                                        "name": "Rules_Description4",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 524,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_0_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "winWaysContainer",
                                "name": "winWaysContainer",
                                "type": "Container",
                                "x": -50,
                                "y": 0,
                                "visible": true,
                                child: [
                                    {
                                        "id": "WinWays_Heading",
                                        "name": "WinWays_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 260,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description1",
                                        "name": "WinWays_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_1_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description1_zs",
                                        "name": "WinWays_Description1_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_1_0",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description2",
                                        "name": "WinWays_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 461,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_1_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                     {
                                        "id": "WinWays_Description2_zs",
                                        "name": "WinWays_Description2_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 370,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_1_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    }, 
                                    {
                                        "id": "WinWays_Description3",
                                        "name": "WinWays_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 542,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_1_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description3_zs",
                                        "name": "WinWays_Description3_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 442,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_1_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description4",
                                        "name": "WinWays_Description4",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 624,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_1_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "WinWays_Description4_zs",
                                        "name": "WinWays_Description4_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 524,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_1_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "tumblesContainer",
                                "name": "tumblesContainer1",
                                "type": "Container",
                                "x": 0,
                                "y": 325,
                                "visible": true,
                                child: [
                                    {
                                        "id": "tumbles_Heading",
                                        "name": "tumbles_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 268,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "tumbles_Description1",
                                        "name": "tumbles_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_2_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "tumbles_Description1_zs",
                                        "name": "tumbles_Description1_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_2_0",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "tumbles_Description2_1",
                                        "name": "tumbles_Description2_1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 375,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_2_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "tumbles_Description3",
                                        "name": "tumbles_Description3",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 425,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_2_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "tumbles_Description3_zs",
                                        "name": "tumbles_Description3_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 425,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_2_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "horizontalReelsContainer",
                                "name": "horizontalReelsContainer1",
                                "type": "Container",
                                "x": -50,
                                "y": 435,
                                "visible": true,
                                child: [
                                    {
                                        "id": "horizontalReels_Heading",
                                        "name": "horizontalReels_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description1",
                                        "name": "horizontalReels_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_3_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description1_jp",
                                        "name": "horizontalReels_Description1_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_3_0",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description2",
                                        "name": "horizontalReels_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 381,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_3_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description2_jp",
                                        "name": "horizontalReels_Description2_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 381,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_3_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description3",
                                        "name": "horizontalReels_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 431,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_3_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description3_jp",
                                        "name": "horizontalReels_Description3_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 431,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_3_2",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "wildsContainer",
                                "name": "wildsContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 670,
                                "visible": true,
                                child: [
                                    {
                                        "id": "wilds_Heading",
                                        "name": "wilds_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_4",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "wilds_Description1",
                                        "name": "wilds_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 2000,
                                        "visible": true,
                                        "text": "tag-help-rules_4_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "wilds_Description2",
                                        "name": "wilds_Description2",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 326,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_4_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "wilds_Description2_zs",
                                        "name": "wilds_Description2_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 356,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_4_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                
                                    {
                                        "id": "wilds_Description3",
                                        "name": "wilds_Description3",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 408,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_4_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "scatterContainer",
                                "name": "scatterContainer2",
                                "type": "Container",
                                "x": -50,
                                "y": 699,
                                "visible": true,
                                child: [
                                    {
                                        "id": "scatter_Heading",
                                        "name": "scatter_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_5",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "scatter_Description1",
                                        "name": "scatter_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_5_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "scatter_Description1_zs",
                                        "name": "scatter_Description1_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_5_0",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "scatter_Description2",
                                        "name": "scatter_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 380,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_5_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "scatter_Description2_zs",
                                        "name": "scatter_Description2_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 380,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_5_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "scatter_Description3",
                                        "name": "scatter_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 455,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_5_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "scatter_Description3_jp",
                                        "name": "scatter_Description3_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 455,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_5_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                ]
                            },

                            {
                                "id": "randomwildContainer",
                                "name": "randomwildContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 911,
                                "visible": true,
                                child: [
                                    {
                                        "id": "randomwild_Heading",
                                        "name": "randomwild_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_6",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "randomwild_Description1",
                                        "name": "randomwild_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 2000,
                                        "visible": true,
                                        "text": "tag-help-rules_6_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "randomwild_Description1_zs",
                                        "name": "randomwild_Description1_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_6_0",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    // {
                                    //     "id": "randomwild_Description2",
                                    //     "name": "randomwild_Description2",
                                    //     "type": "Text",
                                    //     "x": 200,
                                    //     "y": 360,
                                    //     "width": 2000,
                                    //     "visible": true,
                                    //     "text": "randomwildDescription2",
                                    //     "scaleToFit": true,
                                    //     "anchor": [0, 0],
                                    //     "textStyle": {
                                    //         fontFamily: 'Oswald-Regular',
                                    //         fontSize: 24,
                                    //         fontStyle: 'normal',
                                    //         fill: ['#848484'],
                                    //         wordWrap: true,
                                    //         wordWrapWidth: 600
                                    //     },
                                    // },
                                ]
                            },

                            {
                                "id": "lockedReelContainer",
                                "name": "lockedReelContainer2",
                                "type": "Container",
                                "x": -50,
                                "y": 1019,
                                "visible": true,
                                child: [
                                    {
                                        "id": "lockedReel_Heading",
                                        "name": "lockedReel_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_7",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description1",
                                        "name": "lockedReel_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_7_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "lockedReel_Description1_jp",
                                        "name": "lockedReel_Description1_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_7_0",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description2",
                                        "name": "lockedReel_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 378,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_7_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description2_jp",
                                        "name": "lockedReel_Description2_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 378,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_7_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description3",
                                        "name": "lockedReel_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 460,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_7_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description3_jp",
                                        "name": "lockedReel_Description3_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 460,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_7_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                ]
                            },

                            {
                                "id": "fgmultiplierContainer",
                                "name": "fgmultiplierContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 1070,
                                "visible": true,
                                child: [
                                    {
                                        "id": "fgmultiplier_Heading",
                                        "name": "fgmultiplier_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_8",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "fgmultiplier_Description1",
                                        "name": "fgmultiplier_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 290,
                                        "width": 2000,
                                        "visible": true,
                                        "text": "tag-help-rules_8_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "fgmultiplier_Description1_jp",
                                        "name": "fgmultiplier_Description1_jp",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 290,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_8_0",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "fgmultiplier_Description2",
                                        "name": "fgmultiplier_Description2",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 370,
                                        "width": 2000,
                                        "visible": true,
                                        "text": "tag-help-rules_8_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "fgmultiplier_Description2_jp",
                                        "name": "fgmultiplier_Description2_jp",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 370,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_8_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "buyfreespinContainer",
                                "name": "buyfreespinContainer2",
                                "type": "Container",
                                "x": -50,
                                "y": 1320,
                                "visible": true,
                                child: [
                                    {
                                        "id": "buyfreespin_Heading",
                                        "name": "buyfreespin_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_9",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description1",
                                        "name": "buyfreespin_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "buyfreespin_Description1_zs",
                                        "name": "buyfreespin_Description1_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_0",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description2",
                                        "name": "buyfreespin_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 380,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "buyfreespin_Description2_zs",
                                        "name": "buyfreespin_Description2_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 380,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description3",
                                        "name": "buyfreespin_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 470,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "buyfreespin_Description3_zs",
                                        "name": "buyfreespin_Description3_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 470,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_2",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description4",
                                        "name": "buyfreespin_Description4",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 553,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "buyfreespin_Description4_zs",
                                        "name": "buyfreespin_Description4_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 553,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_3",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description5",
                                        "name": "buyfreespin_Description5",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 640,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9_4",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "additionalContainer",
                                "name": "additionalContainer2",
                                "type": "Container",
                                "x": 0,
                                "y": 1318,
                                "visible": true,
                                child: [
                                    {
                                        "id": "additional_Heading",
                                        "name": "additional_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_10",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description1",
                                        "name": "additional_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description2",
                                        "name": "additional_Description2",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 380,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "additional_Description2_zs",
                                        "name": "additional_Description2_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 380,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description3",
                                        "name": "additional_Description3",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 460,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description4",
                                        "name": "additional_Description4",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 518,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description4_zs",
                                        "name": "additional_Description4_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 518,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_3",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description5",
                                        "name": "additional_Description5",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 597,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_4",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description5_zs",
                                        "name": "additional_Description5_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 597,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_4",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description6",
                                        "name": "additional_Description6",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 675,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_5",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                    {
                                        "id": "additional_Description6_zs",
                                        "name": "additional_Description6_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 675,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_5",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 20,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },

                                     
                                    {
                                        "id": "additional_Description7",
                                        "name": "additional_Description7",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 780,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_6",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                    {
                                        "id": "additional_Description8",
                                        "name": "additional_Description8",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 850,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10_7",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 24,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 600
                                        },
                                    },
                                ]
                            },


                        ]
                    },
                ]
            },

        ],
    }


};

export const GameGuideComponentConfigurationContext = React.createContext(
    {}
);